import { render, staticRenderFns } from "./Alertbusiness.vue?vue&type=template&id=07a94e27&scoped=true&"
import script from "./Alertbusiness.vue?vue&type=script&lang=ts&"
export * from "./Alertbusiness.vue?vue&type=script&lang=ts&"
import style0 from "./Alertbusiness.vue?vue&type=style&index=0&id=07a94e27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a94e27",
  null
  
)

export default component.exports